/*ReactJS*/
import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';

/*Material-ui*/
import {
  Typography,
  Button,
  Modal,
  Backdrop,
  Fade,
  Box,
  TextField,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';

import { checkEntryType } from '../../../services/TransactionService';

// import SelectCorrespondent from '../../../components/AutoComplete/SelectCorrespondent';
// import AccountNoSelect from '../../../components/AutoComplete/SelectAccountNo';
import SelectAccount from '../../../components/AutoComplete/SelectAccount';
import SelectSymbol from '../../../components/AutoComplete/SelectSymbol';
import VendorSelect from '../../../components/AutoComplete/Vendor';
import EntryTypeSelect from '../../../components/AutoComplete/EntryType';
import SelectCurrency from 'components/AutoComplete/Currency';
import DateInputWarning from 'components/Input/DateInputWarning';

import moment from 'moment-timezone';

export default function AccountUploadEditModal({
  onClose: handleClose,
  open: isOpen,
  value,
}) {
  const classes = useStyles();
  const [modalData, setModalData] = useState({});

  const err = 'Missing Value';

  useEffect(() => {
    if (isOpen) {
      setModalData({ ...value });
    }
  }, [isOpen, value]);

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;
    setModalData({
      ...modalData,
      [input.name]: input.value,
    });
  };

  const formatDateTime = (v) => {
    return moment(new Date(v)).format('YYYY-MM-DDTh:mm');
  };

  const formatDate = (v) => {
    return moment(new Date(v)).format('YYYY-MM-DD');
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalBackdrop}
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div className={classes.fadeModalFull}>
          <Typography
            id="transition-modal-title"
            variant="h4"
            className={classes.textBold}
            gutterBottom
          >
            Edit Entries
          </Typography>
          <Box mt={5}>
            <form noValidate autoComplete="off">
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <SelectAccount
                    freeSolo={false}
                    type="correspondent"
                    name="correspondent"
                    label="Correspondent"
                    value={modalData.correspondent}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <SelectAccount
                    freeSolo={false}
                    type="accountNo"
                    name="accountNo"
                    label="Account No"
                    value={
                      modalData.accountNo !== err ? modalData.accountNo : ''
                    }
                    showAccountName={true}
                    onChange={handleChange}
                    selectedCorrespondent={
                      modalData.correspondent ? modalData.correspondent : ''
                    }
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <EntryTypeSelect
                    freeSolo={false}
                    name="entryType"
                    label="Entry Type"
                    value={
                      modalData.entryType !== err ? modalData.entryType : ''
                    }
                    onChange={handleChange}
                    allowInputChange={true}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <SelectAccount
                    freeSolo={false}
                    disabled={checkEntryType(modalData.entryType) === 'pm'}
                    type="correspondent"
                    name="contraCorrespondent"
                    label="Contra Correspondent"
                    value={modalData.contraCorrespondent}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <SelectAccount
                    freeSolo={false}
                    type="accountNo"
                    name="contraAccountNo"
                    label="Contra Account No"
                    value={
                      modalData.contraAccountNo !== err
                        ? modalData.contraAccountNo
                        : ''
                    }
                    showAccountName={true}
                    onChange={handleChange}
                    selectedCorrespondent={''}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <InputLabel shrink>Side</InputLabel>
                  <Select
                    fullWidth
                    name="side"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.side !== err ? modalData.side : ''}
                    onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>Blank</em>
                    </MenuItem>
                    <MenuItem value="sell">sell</MenuItem>
                    <MenuItem value="sell_short">sell_short</MenuItem>
                    <MenuItem value="buy">buy</MenuItem>
                  </Select>
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <SelectSymbol
                    freeSolo={true}
                    name="symbol"
                    label="Symbol"
                    type="symbol"
                    disabled={checkEntryType(modalData.entryType) === 'cm'}
                    value={modalData.symbol !== err ? modalData.symbol : ''}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <SelectSymbol
                    freeSolo={true}
                    name="cusip"
                    label="Cusip"
                    type="cusip"
                    disabled={checkEntryType(modalData.entryType) === 'cm'}
                    value={modalData.cusip !== err ? modalData.cusip : ''}
                    onChange={handleChange}
                    selectedSymbol={modalData.symbol ? modalData.symbol : ''}
                    date={
                      modalData.tradeDate
                        ? moment(Date.parse(modalData.tradeDate)).format(
                          'YYYY-MM-DD'
                        )
                        : ''
                    }
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="qty"
                    label="Qty"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) === 'cm'}
                    value={modalData.qty !== err ? modalData.qty : ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="price"
                    label="Price"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) === 'cm'}
                    value={modalData.price !== err ? modalData.price : ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <VendorSelect
                    name="vendor"
                    label="Vendor"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'trd' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.vendor}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="tradeDate"
                    label="Trade Date"
                    type="datetime-local"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={
                      modalData.tradeDate !== err
                        ? formatDateTime(modalData.tradeDate)
                        : ''
                    }
                    onInput={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <DateInputWarning
                    value={
                      modalData.tradeDate !== err
                        ? formatDateTime(modalData.tradeDate)
                        : ''
                    }
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="settleDate"
                    label="Settle Date"
                    type="date"
                    value={formatDate(modalData.settleDate)}
                    onInput={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <DateInputWarning value={formatDate(modalData.settleDate)} />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="holdDate"
                    label="Hold Date"
                    type="date"
                    disabled={
                      modalData.entryType !== 'ACATC' &&
                      (checkEntryType(modalData.entryType) === 'cm' ||
                        checkEntryType(modalData.entryType) === 'trd')
                    }
                    value={formatDate(modalData.holdDate)}
                    onInput={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <DateInputWarning value={formatDate(modalData.holdDate)} />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="grossAmt"
                    label="Gross Amt"
                    type="number"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.grossAmt}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="netAmt"
                    label="Net Amt"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) === 'pm'}
                    value={modalData.netAmt !== err ? modalData.netAmt : ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    fullWidth
                    name="fees"
                    label="Fees"
                    type="number"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.fees}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="executionId"
                    label="Execution ID"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.executionId}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="externalId"
                    label="External ID"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.externalId}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="executingVenue"
                    label="Execution Venue"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.executingVenue}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                  <TextField
                    fullWidth
                    name="leavesQty"
                    label="Leaves Qty"
                    type="number"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.leavesQty}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    fullWidth
                    name="orderId"
                    label="Order ID"
                    disabled={
                      checkEntryType(modalData.entryType) === 'pm' ||
                      checkEntryType(modalData.entryType) === 'cm' ||
                      checkEntryType(modalData.entryType) === 'cpm'
                    }
                    value={modalData.orderId}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <InputLabel shrink>Contra Account Designator</InputLabel>
                  <Select
                    fullWidth
                    name="contraAccountDesignator"
                    disabled={checkEntryType(modalData.entryType) === 'cm'}
                    value={modalData.contraAccountDesignator || ''}
                    onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>Blank</em>
                    </MenuItem>
                    <MenuItem value="2">Long (2)</MenuItem>
                    <MenuItem value="3">Short (3)</MenuItem>
                  </Select>
                </div>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <TextField
                    fullWidth
                    name="refId"
                    label="Ref ID"
                    value={modalData.refId}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className={classes.grdCell1}>
                  <TextField
                    fullWidth
                    name="description"
                    label="Description"
                    value={modalData.description}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              </div>
              <div className={classes.grdRow}>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <SelectCurrency
                    freeSolo={false}
                    name="contraSymbol"
                    label="Currency"
                    disabled={checkEntryType(modalData.entryType) === 'pm'}
                    value={modalData.contraSymbol}
                    onChange={handleChange}
                  />
                </div>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <TextField
                    fullWidth
                    name="swapRate"
                    label="Swap Rate"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) === 'pm'}
                    value={modalData.swapRate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <TextField
                    fullWidth
                    name="swapRateAt"
                    label="Swap Rate At"
                    type="datetime-local"
                    disabled={checkEntryType(modalData.entryType) === 'pm'}
                    value={
                      modalData.swapRateAt !== err
                        ? formatDateTime(modalData.swapRateAt)
                        : ''
                    }
                    onInput={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                  <DateInputWarning
                    value={
                      modalData.swapRateAt !== err
                        ? formatDateTime(modalData.swapRateAt)
                        : ''
                    }
                  />
                </div>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <TextField
                    fullWidth
                    name="swapFeeBpsAlpa"
                    label="Swap Fee Bps Alpa"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) !== 'trd'}
                    value={modalData.swapFeeBpsAlpa}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <TextField
                    fullWidth
                    name="swapFeeBpsCorr"
                    label="Swap Fee Bps Corr"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) !== 'trd'}
                    value={modalData.swapFeeBpsCorr}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 30, width: 245 }}
                >
                  <TextField
                    fullWidth
                    name="localFees"
                    label="Local Feesr"
                    type="number"
                    disabled={checkEntryType(modalData.entryType) !== 'trd'}
                    value={modalData.localFees}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              </div>
              <div className={classes.modalFooter}>
                <div
                  className={classes.grdCellNone}
                  style={{ marginRight: 10 }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Close
                  </Button>
                </div>
                <div className={classes.grdCellNone}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    onClick={() => {
                      handleClose(modalData);
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </form>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
}
